import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';
import ModalToaster from 'react/components/Modal/ModalToaster';

class ToasterContainer extends React.Component {
  dequeueToast = (key) => {
    const { dequeueToastAction, routeId, stopId } = this.props;
    dequeueToastAction(routeId, stopId, key);
  }

  render() {
    const { toasts } = this.props;
    return (
      <ModalToaster
        toasts={toasts}
        closeToasterFn={this.dequeueToast}
        dismissTimeoutMS={6000}
      />
    );
  }
}

ToasterContainer.propTypes = {
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  toasts: PropTypes.object.isRequired,
  dequeueToastAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, { routeId, stopId }) => ({
  toasts: selectors.getToasts(state, routeId, stopId)
});

const mapDispatchToProps = {
  dequeueToastAction: actionCreators.dequeueToast
};

export default connect(mapStateToProps, mapDispatchToProps)(ToasterContainer);
